// 业务js加载时间
// global.__biz_start_time__ = Date.now();
/* eslint-disable */
import { Text } from 'react-native';
import { FontLoader } from 'qunar-react-native';
import '@qnpm/react-native-ext';
import '../utils/fetch';
import '../utils/navigate';
import '../utils/qav';
// import '../utils/perfQav';
// import '../utils/toast';
/* eslint_enable */

FontLoader.loadFontSet(require('../assets/QFontSet'));
global.QImageSet = require('../assets/QImageSet');
// 禁止字体缩放
// Text.defaultProps.allowFontScaling = false;
Text.defaultProps={...(Text.defaultProps||{}),allowFontScaling:false};

Ext.defaults = {
    // 配置业务 hybridId，在多业务跳转时会用到
    hybridId: 'cmn_order_rn',
    // 配置首页（可以不配置，默认为 require 的第一个页面）
    indexView: 'OrderMain',
    // 配置全局导航栏
    navBar: {
        // 是否显示，默认为 false，不显示
        isShow: false,
        // 背景色，默认 Qunar 蓝
        backgroundColor: 'white',
        // 导航栏文字颜色，默认白色
        color: 'black',
        // 导航栏高度,默认44(不包括状态栏高度)
        height: 44,
        // 左右按钮宽度,默认60
        buttonWidth: 60,
        // 状态栏背景色,默认透明
        statusBarBackgroundColor: 'white',
        // 导航栏按钮点击不透明度，默认 0.6
        activeOpacity: 0.8,
        // 左侧按钮文字,默认'返回'
        leftButtonText: '返回'
    }
};
